import React, { useEffect, useRef, useState } from "react";

const BringzzReadOnlyMap = ({ startLocation, endLocation }) => {
  const mapRef = useRef();
  const [map, setMap] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!mapRef.current || !window.mapkit) return;

    const initializeMap = () => {
      try {
        // Initialize Apple MapKit
        window.mapkit.init({
          authorizationCallback: (done) => {
            done(process.env.REACT_APP_APPLE_MAP_KEY || "eyJraWQiOiIyREpSVjk1V05TIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJLOVdNVDVBVjlHIiwiaWF0IjoxNzU2ODg4MDEzLCJleHAiOjE3NTc1NzM5OTl9.OdcqVU6_-Atk8fbui9vDBYU9z_hY0iAtGuWJGb9I72ytjngR-vsdUOUDgAiYYywwAB5sMfSVsz6UTLjLmTl5SA");
          },
        });

        // Create map instance with disabled controls
        const newMap = new window.mapkit.Map(mapRef.current, {
          mapType: window.mapkit.Map.MapTypes.Standard,
          showsCompass: window.mapkit.FeatureVisibility.Hidden,
          showsMapTypeControl: false,
          showsScale: window.mapkit.FeatureVisibility.Hidden,
          isZoomEnabled: false, // Prevents zoom
          isScrollEnabled: false, // Prevents scrolling (equivalent to gestureHandling: "none")
          showsZoomControl: false,
          isRotateEnabled: false, // Prevents rotation
        });

        // Create coordinates for start and end locations
        const startCoordinate = new window.mapkit.Coordinate(
          startLocation.lat || startLocation.latitude,
          startLocation.lng || startLocation.longitude
        );
        const endCoordinate = new window.mapkit.Coordinate(
          endLocation.lat || endLocation.latitude,
          endLocation.lng || endLocation.longitude
        );

        // Create markers for start and end points
        const startAnnotation = new window.mapkit.MarkerAnnotation(startCoordinate, {
          title: "Start",
          color: "#00D084", // Green color for start
        });

        const endAnnotation = new window.mapkit.MarkerAnnotation(endCoordinate, {
          title: "Destination",
          color: "#FF3B30", // Red color for end
        });

        // Add markers to the map
        newMap.addAnnotations([startAnnotation, endAnnotation]);

        // Create directions request
        const directionsRequest = new window.mapkit.Directions();
        
        directionsRequest.route(
          {
            origin: startCoordinate,
            destination: endCoordinate,
            transportType: window.mapkit.Directions.Transport.Walking, // Using walking as bicycle is not available
          },
          (error, data) => {
            if (error) {
              setError("Could not calculate route between these locations");
              console.error("Directions error:", error);
              // Even if route fails, fit map to show both markers
              const bounds = new window.mapkit.BoundingRegion(
                startCoordinate.latitude,
                startCoordinate.longitude,
                endCoordinate.latitude,
                endCoordinate.longitude
              );
              newMap.region = bounds.toBoundingRegion();
            } else if (data.routes && data.routes.length > 0) {
              // Display the route on the map
              const route = data.routes[0];
              const polyline = route.polyline;
              
              // Style the polyline
              polyline.style = new window.mapkit.Style({
                lineWidth: 4,
                strokeColor: "#007AFF",
                lineJoin: "round",
                lineDash: [],
              });
              
              // Add the polyline to the map
              newMap.addOverlay(polyline);
              
              // Fit the map to show the entire route with padding
              const padding = new window.mapkit.Padding(50, 50, 50, 50);
              newMap.showItems([polyline], {
                padding: padding,
                animate: false,
              });
              
              setError(null);
            }
          }
        );

        setMap(newMap);
        setLoading(false);
      } catch (err) {
        console.error("Map initialization error:", err);
        setError("Failed to initialize map");
        setLoading(false);
      }
    };

    // Initialize map when MapKit is ready
    if (window.mapkit) {
      initializeMap();
    } else {
      // Wait for MapKit to load
      const checkMapKit = setInterval(() => {
        if (window.mapkit) {
          clearInterval(checkMapKit);
          initializeMap();
        }
      }, 100);

      return () => clearInterval(checkMapKit);
    }

    // Cleanup
    return () => {
      if (map) {
        map.destroy();
      }
    };
  }, [startLocation, endLocation]);

  return (
    <div className="relative w-full h-full">
      <div ref={mapRef} className="w-full min-h-[250px] h-full" />
      {loading && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <span>Loading map...</span>
        </div>
      )}
      {error && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-red-100 text-red-700 px-4 py-2 rounded">
          {error}
        </div>
      )}
    </div>
  );
};

export default BringzzReadOnlyMap;